<!-- stateful-primary-button component -->
<div 
    class="stateful-primary-button" 
    [attr.aria-label]="this.text + ' button'"
>
    <a 
        class="{{this.selected ? 'selected' : ''}} {{this.colorCssClass}}"
        (click)="this.submit()" 
        (keydown.Space)="this.submit()"
        (keydown.enter)="this.submit()" 
        tabindex="0"
    >
        <span *ngIf="!this.selected" class="{{this.fontSizeCssClass}} {{this.textPropsCssClass}}" [innerHTML]="this.text"></span>
        <span *ngIf="this.selected" class="{{this.fontSizeCssClass}}">
            <kendo-loader
            [type]="loader.type"
            [themeColor]="loader.themeColor"
            [size]="loader.size"
            >
            </kendo-loader>
        </span>
    </a>
</div>
